/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
    var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {

    $(document).on("click", ".accordion__button", function(e){
        if ($(this).closest(".accordion").hasClass("is--active")) {
            $(this).closest(".accordion").removeClass("is--active");
        } else {
            $(".accordion.is--active").removeClass("is--active");
            $(this).closest(".accordion").addClass("is--active");
        }
    });
    
});

// END jQuery Ready
function detectScrollbarWidth() {
    /* Detect scrollbar width to properly center full- and wide-width elements */
    let root = document.documentElement;
    var outside = document.createElement("div");
    var inside = document.createElement("div");
    
    outside.style.width = inside.style.width = "100%";
    outside.style.overflow = "scroll";
    document.body.appendChild(outside).appendChild(inside);
    
    var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;
    
    outside.parentNode.removeChild(outside);
    root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
    var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

    headings.forEach(function (head, index) {
        let str = head.textContent;
        let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
        let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

        firstSection = firstSection.trim();

        let newStr = firstSection + "\u00a0" + lastSection;

        head.innerHTML = newStr;
    });
}



// $(document).ready(function () {
// 	var cursor = $(".msg-reveal-interaction__cursor-lense");
// 	$(window).mousemove(function (e) {
// 		cursor.css({
// 			top: e.clientY - cursor.height() / 2,
// 			left: e.clientX - cursor.width() / 2
// 		});
// 	});
// 	// $(document).on('mousemove scroll', function (e) {
// 	// 	// console.log('cursor' + e.clientY);
// 	// 	// console.log('page' + e.pageY);
// 	// 	console.log(e);
// 	// 	cursor.css({
// 	// 		top: e.clientY - cursor.height() / 2,
// 	// 		left: e.clientX - cursor.width() / 2
// 	// 	});
// 	// });
// 	$(".msg-reveal-interaction")
// 		.mouseleave(function () {
// 			cursor.removeClass('active');
// 			cursor.css({ transform : 'scale(0)' });
// 		})
// 		.mouseenter(function () {
// 			cursor.addClass('active');
// 			cursor.css({ transform : 'scale(1)'});
// 		})
// });
